import { MessageSquare, ClipboardList, PenTool, Rocket, LifeBuoy, Check } from "lucide-react";

const STEPS = [[MessageSquare, "Ci racconti"], [ClipboardList, "Proposta scritta"], [PenTool, "Design"], [Rocket, "Online"], [LifeBuoy, "Gestione"]];
const WHY = ["Prezzi pubblici", "Qualità premium", "Assistenza continua", "In tutta Italia", "Zero tecnicismi"];

export default function WhyProcess() {
  return (
    <section className="relative overflow-hidden bg-p-flow py-12 md:py-16">
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-60" />
      <div className="wrap relative">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">Online in 5 passi. <span className="hl-light">Senza pensieri.</span></h2>
          <ul className="snap-row !gap-2 !pb-0 lg:flex-wrap">
            {WHY.map((w) => <li key={w} className="chip border-slate-200 bg-white/80 text-slate-800"><Check className="h-3.5 w-3.5 text-blue-600" />{w}</li>)}
          </ul>
        </div>
        <ol className="relative mt-8 grid grid-cols-5 gap-2">
          <span className="absolute left-[10%] right-[10%] top-6 h-px bg-gradient-to-r from-blue-300 via-violet-300 to-emerald-300" aria-hidden="true" />
          {STEPS.map(([I, t], i) => (
            <li key={t} className="group relative flex flex-col items-center text-center">
              <span className="grid h-12 w-12 place-items-center rounded-2xl border border-slate-200 bg-white text-blue-600 shadow-[0_10px_24px_-14px_rgba(39,83,245,0.5)] transition-[transform,background-color] group-hover:-translate-y-1 group-hover:bg-blue-600 group-hover:text-white"><I className="h-5 w-5" /></span>
              <span className="mt-1 text-[10px] font-semibold text-slate-600">0{i + 1}</span>
              <span className="text-xs font-semibold text-slate-900 sm:text-sm">{t}</span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
